<template>
  <div class="stay-modal-wrapper">
    <transition name="fade">
      <div v-if="visible" class="mask"></div>
    </transition>
    <transition name="scale">
      <div v-if="visible" class="stay-modal-container flex flex-col items-center">
        <div class="title">只差最后一步，基本信息要填写完整哦～</div>
        <OnboardingBtn text="继续填写" :width="184" @click="close" />
      </div>
    </transition>
  </div>
</template>
<script>
import OnboardingBtn from './OnboardingBtn.vue';
export default {
  name: 'StayModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    OnboardingBtn,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 299;
}
.stay-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 301;
  width: 341px;
  height: 152px;
  border-radius: 16px;
  background: #25272d;
  padding: 32px;
  box-sizing: border-box;
  .title {
    font-size: 14px;
    color: #fff;
    margin-bottom: 24px;
  }
}
</style>
